export default __webpack_public_path__ + "static/media/eudemon_logo_160.4b4c8d20.webp";